module.exports = __webpack_public_path__ + "assets/655f27214a13508f3bc66853ecb0fa35.png";